module.exports = __webpack_public_path__ + "img/plus_personal.f385a297.png";